<template>
  <div>
     <login @login="login"></login>
     <hr>
     <b-row>
       <b-col sm="12">
         <p class="text-center py-1"><translate>Request the user and password</translate> <router-link :to="{ name: 'Public/Subscribe' }" class="link"><translate>here</translate></router-link> </p>
       </b-col>
       <b-col sm="12" class="text-center">
         <b-icon icon="telephone" class="mr-2"/>
         <b>0034-922724642 / 0034-638657916 / 0034-638894129</b>
       </b-col>
     </b-row>
  </div>
</template>

<script>
import auth from 'b2b-common/services/auth'
import login from '@/shared/components/login'

import toast from 'b2b-common/mixins/toast'

export default {
  components: { login },
  mixins: [toast],
  methods: {
    login ({ client, username, password }) {
      auth.login({ client, username, password })
        .then(res => {
          if (res) {
            this.addToast({
              message: this.$gettext('Welcome to Mario Viajes B2b'),
              title: this.$gettext('Login'),
              variant: 'success'
            })
            this.$router.push({ name: 'Private/Default' })
          } else {
            this.addToast({
              message: this.$gettext('Please check the data entered in the form. Client code, username or password are invalid.'),
              title: this.$gettext('Invalid login'),
              variant: 'danger'
            })
          }
        }).catch(() => {
          this.addToast({
            message: this.$gettext('Invalid form'),
            title: this.$gettext('Invalid login'),
            variant: 'danger'
          })
        })
    }
  }

}
</script>
